/*****************************************************************************
*
* MCAFEE CONFIDENTIAL
* Copyright (c)2017 McAfee, LLC
*
* The source code contained or described herein and all documents related
* to the source code ("Material") are owned by McAfee or its
* suppliers or licensors. Title to the Material remains with McAfee
* or its suppliers and licensors. The Material contains trade
* secrets and proprietary and confidential information of McAfee or its
* suppliers and licensors. The Material is protected by worldwide copyright
* and trade secret laws and treaty provisions. No part of the Material may
* be used, copied, reproduced, modified, published, uploaded, posted,
* transmitted, distributed, or disclosed in any way without McAfee's prior
* express written permission.
*
* No license under any patent, copyright, trade secret or other intellectual
* property right is granted to or conferred upon you by disclosure or
* delivery of the Materials, either expressly, by implication, inducement,
* estoppel or otherwise. Any license under such intellectual property rights
* must be expressed and approved by McAfee in writing.
*
****************************************************************************/
//import { } from "./common";
import { ModuleManager , globalEngine } from "./Init";
import { StartEngine } from "./engine";
//import { CreateAnalyticsTransport } from "./transport";
import { CreateAnalyticsTransport } from "./transport";
import { EventTransmitterTemplate } from "./transmitter_template";
import { Create_data_collector } from "./data_collector";
import { CreateDataOperations } from "./operations";
import { createUWPStorage } from "./uwp_storage";
import { CreateHasher128 } from "./hash128";
import { CreateRegistryHelper } from "./registry";
import { CreateEventHandler } from "./event_handler";
import { getObservationAnalyticsEngine } from "./observation_analytics";
import { CreateMcUtilHelper } from "./mcutil";
import { CreateEventConfig } from "./config_manager";
import { CreateAnalyticsErrorTransmitter } from "./error_transmitter";
import { getEventTransportProfiles } from "./transport_config";
import { getEventConfiguration } from "./event_config";
import { CreatePriorityConfig } from "./priority_config";
import { CreateMapping } from "./mappings";
import { CreateRules } from "./rules";
import { CreateDataset } from "./dataset";
import { createEmitter } from "./emitter";
import { CreateEventHubTransport } from "./transport_event_hub";
import { CreateXMLHttpWrapper } from "./xmlHttpComObj";
import { TransportPlugin_Template } from "./transport_template";

/*import da_definitions_json from "./da_definitions.json";
import data_items_json from "./data_items.json";
import datasets_catalog_json from "./datasets_catalog.json";
import dictionary_json from "./dictionary.json";
import events_json from "./events.json";
import profile_json from "./profile.json";*/
import { RESTtransportPlugin } from "./rest_transport";



//var bootstrapFileVersion = "[MAJORVERSION].[MINORVERSION].[BUILDNUMBER].[PACKAGENUMBER]";
export var bootstrapFileVersion = null;
export var enableWebPack = true;
export var debugEnable = true;
var GetConfigURL  = "./node_modules/AnalyticsSDK/";
export function fillURL(url)
{
    GetConfigURL = url;
}

//globalEngine _cleanAll function definition (temp), This will be replaced by engine.js _cleanAll definition
globalEngine.__cleanAll = function()
                {
                    // Notify Cleanup
                    logConsole("old cleanAll call");
                }; //Gecko + IE


export function sendRequestInJSRT(url,headers,eventDataString)
{
    logNormal("sending events through common interface");

    try
        {
            const xhr = new XMLHttpRequest();

            if(!xhr)
            {
                logError('sendRequestInJSRT: couldnt create a xmlHttpRequest');
                return null;
            }

            xhr.open("POST", url , false);
            for (var key in headers)
            {
                xhr.setRequestHeader(key, headers[key]);
            }

            xhr.send(eventDataString);

            var sendStatusCode = xhr.status;
            var sendResponse = xhr.responseText;

            if(sendStatusCode == 201)
                return sendStatusCode;
            else
            {
                logError('sendRequestInJSRT: request failed with '+ sendStatusCode + 'status code and ' + sendResponse +'response' );
                return null;
            }

            
        }
        catch (e)
        {
            logError('sendRequestInJSRT. Exception caught with message: ' + e.message);
            return null;
        }
        
    return null;
}

export function queryGeoInfoUWP()
{
    try
    {
        //Qa test version
        var funcUrl = 'https://qa-mcafee-mosaic-pub.azurewebsites.net/api/geoiplookup?code=x6OlAoOfPliixzULPOqkOwIiPXR4CKPmdNUl7gYvX14WkVASbAUFag==';
        var xhr = new XMLHttpRequest();
        if(!xhr)
        {
            logError('queryGeoInfoUWP: couldnt create a xmlHttpRequest');
            return null;
        }
        xhr.open("GET", funcUrl , false);
        xhr.send();
        return xhr.getAllResponseHeaders();
    }
    catch(e)
    {
        logError('queryGeoInfoUWP: ' + e.message);
    }
}


function Queue(){
    var data=[];
    this.getLength=function(){return data.length};
    this.IsEmpty=function(){return 0==data.length};
    this.Push=function(b){data.push(b)};
    this.Pop=function(){data.shift()};
    this.Front=function(){return 0<data.length?data[0]:null}
};


export function logConsole(msg)
{
   //host.echo(msg+ "  ");   
   console.log(msg);
}

export function logNormal(msg)  { 
    //logConsole("[NORMAL]: " + msg);
 }
export function  logInformation(msg) {
     //logConsole("[INFO]: " + msg); 
    }
export function  logWarning(msg) { logConsole("[WARN]: " + msg); }
export function  logError(msg) { logConsole("[ERROR]: " + msg); }
export function  logDebug(msg) { logConsole("[DEBUG]: " + msg); }

export function  logRawTrack(unique_id, payload)
{
    try
    {
        logConsole("UWP:[logRawTrack]: " + unique_id + payload);
    }
    catch (e)
    {

    }
}

export function  logTransports(unique_id, transport, success, payload)
{
    try
    {
        logConsole("UWP:[logTransports]: " + unique_id + transport + success + payload);
    }
    catch (e)
    {

    }
}

export function  logAutomationError(unique_id, payload, error)
{
    try
    {
        logConsole("UWP:[logAutomationError]: " + unique_id + payload + error);
    }
    catch (e)
    {

    }
}

// END BASIC logging


export var scriptHelper =
{
    "setPath": function(path)
    {
        logNormal("UWP:SetPath");
    
    },
    "loadScript": function (fileName)
    {
		/*logNormal("UWP:loadScript");
		var fileNameWithoutExt="abc";
		//var fileNameWithoutExt = fileName.substring(0, fileName.indexOf('.js'));
		var createFunction = "Create_".concat(fileName);
		//ModuleManager.registerFactory(fileNameWithoutExt, createFunction);
		logNormal("loaded completly");
        /*var objXMLHttp=null;
    if (window.XMLHttpRequest)
    {
        objXMLHttp=new XMLHttpRequest();
    }
    else if (window.ActiveXObject)
    {
        objXMLHttp=new ActiveXObject("Microsoft.XMLHTTP");
    }

        var xhrObj = objXMLHttp;
        // open and send a synchronous request
        xhrObj.open('GET', fileName, false);
        xhrObj.send('');
        // add the returned content to a newly created script tag
        var se = document.createElement('script');
        se.type = "text/javascript";
        se.text = xhrObj.responseText;
        document.getElementsByTagName('head')[0].appendChild(se);    */
        return true;
 
    },
    "getLoadedVersion": function (name)
    {
        logNormal("UWP(No-op):getLoadedVersion");
        return name;
    },
    "_initialize": function()
    {
        this.setPath(null);
    },
    "_isLoaded": function (name, version)
    {
        logNormal("UWP(No-op):_isLoaded");
        return true;
        
    },
    "_getDefaultPath": function()
    {
        logNormal("UWP(No-op):_getDefaultPath");
        return null;
    },
    "_updateCache": function (name, version, state)
    {
        logNormal("UWP(No-op):_updateCache");
    },
    "_readRawText": function (fileName)
    {
       try{
            logConsole("readrawtext '" + fileName + "'");
            /*var fileNameWithoutExt = fileName.substring(0, fileName.indexOf('.json'));
            var jsonString = JSON.stringify(globalEngine.JsonDataMap[fileNameWithoutExt]);
            return jsonString;*/
            logNormal("UWP(No-op):_readRawText: reading file :" + fileName);
            var script = '';
            var xmlhttp = new XMLHttpRequest();
            xmlhttp.open("GET",GetConfigURL + fileName,false);
            xmlhttp.send('');
            script = xmlhttp.responseText;

            return script;
       }     catch(e){ 
            logError("Failed to read JSON file "+ fileName +" from server" + e.message);
       }
    },
    "_extractVersion": function (data)
    {
        logNormal("UWP(No-op):_extractVersion");
        return data;
    },
    "_cache": [],
    "_path": null // for some reason we can't actually call 'this._getDefaultPath()' here.
} // end scriptHelper
scriptHelper._initialize();
function fillMap()
{
    // globalEngine.FactoryMap["transport"] =  CreateAnalyticsTransport ;
    // globalEngine.FactoryMap["transmitter_template"] =  EventTransmitterTemplate;
   // globalEngine.FactoryMap["data_collector"] =  Create_data_collector;
    // globalEngine.FactoryMap["operations"] =  CreateDataOperations;
    //globalEngine.FactoryMap["hash128"] =  CreateHasher128;
    // globalEngine.FactoryMap["uwp_storage"] =  createUWPStorage;
   // globalEngine.FactoryMap["registry"] =  CreateRegistryHelper;
    //globalEngine.FactoryMap["event_handler"] =  CreateEventHandler;
   // globalEngine.FactoryMap["observation_analytics"] =  getObservationAnalyticsEngine;
    //globalEngine.FactoryMap["mcutil"] =  CreateMcUtilHelper;
   // globalEngine.FactoryMap["config_manager"] =  CreateEventConfig;
   // globalEngine.FactoryMap["error_transmitter"] =  CreateAnalyticsErrorTransmitter;
    //globalEngine.FactoryMap["transport_config"] =  getEventTransportProfiles;
   //globalEngine.FactoryMap["event_config"] =  getEventConfiguration;
    // globalEngine.FactoryMap["priority_config"] =  CreatePriorityConfig;
    //globalEngine.FactoryMap["mappings"] =  CreateMapping;
    // globalEngine.FactoryMap["rules"] =  CreateRules;
    //globalEngine.FactoryMap["emitter"] =  createEmitter;
    // globalEngine.FactoryMap["transport_event_hub"] = CreateEventHubTransport;
    //globalEngine.FactoryMap["xmlHttpComObj"] =  CreateXMLHttpWrapper;
   // globalEngine.FactoryMap["transport_template"] =  TransportPlugin_Template;
   // globalEngine.FactoryMap["dataset"] =  CreateDataset;
  //  globalEngine.FactoryMap["transport_da"] =  CreateDATransport;
   // globalEngine.FactoryMap["transport_ai"] =  CreateApplicationInsightsTransport;


        
   /* globalEngine.JsonDataMap["da_definitions"] =  da_definitions_json;
    globalEngine.JsonDataMap["data_items"] =  data_items_json;
    globalEngine.JsonDataMap["datasets_catalog"] =  datasets_catalog_json;
    globalEngine.JsonDataMap["dictionary"] =  dictionary_json;
    globalEngine.JsonDataMap["events"] =  events_json;
    globalEngine.JsonDataMap["profile"] =  profile_json;*/
    
};

export function LoadScript(fileName)
{
  //  globalEngine.FactoryMap["transport_template"] = TransportPlugin_Template;
  try{

  /*  fillMap();
	logConsole("LoadScript '" + fileName + "'");
	logNormal("UWP:loadScript");
	var fileNameWithoutExt = fileName.substring(0, fileName.indexOf('.js'));
	//var createFunction = "Create_".concat(fileNameWithoutExt);
	ModuleManager.registerFactory(fileNameWithoutExt, globalEngine.FactoryMap[fileNameWithoutExt]);
	logNormal("loaded completly");
    //scriptHelper.loadScript(fileName);*/

  }
  catch(e)
  {
	  logConsole("exception in loadscript is: " + e.message);
  }
  
};
function GetScriptVersion(fileName)
{
    // NOTE: this only works AFTER the script has been loaded
    // NOTE: this call WILL NOT load the script
    return scriptHelper.getLoadedVersion(fileName);
};

//  <Bootstrap definitions>  those which should always be added
/*function setTimeout(timeOut, callback)    { return timer.setTimeout(timeOut, {"OnTimeout" : callback} ); }
function setInterval(timeOut, callback) { return timer.setInterval(timeOut, {"OnTimeout" : callback} ); }
function clearInterval(id)              { return timer.clearInterval(id); }*/

// object to provide backward compatibility with the older style calls
var eventQueue =
{
    "Push" : function(val) 
    {
        try
        {
            ca_engine_queuehandler(val);
        }
        catch(e){ /*Last effort to catch, we probably shouldn't log for safety*/ }
    }
}

function getEventQueue()                { return eventQueue; }

var ScriptVariableStoreMap = new Map();
var ScriptVariableStore =
{
    "Get": function(key)
    {
        try{

            return ScriptVariableStoreMap.get(key);
        }
        catch(e){}
    },
    "Set": function(key,val)
    {
        try{

            ScriptVariableStoreMap.set(key,val);
        }
        catch(e){}
    }
}
export function getScriptVariableStore()       { return ScriptVariableStore; }
var pluginFactoryMap = new Map();

var PluginFactory =
{
    "Create" : function(val)
    {

       pluginFactoryMap.set(val,val);
       loadScript(val+"_plugin.js");
       initPlugin();
    }

}
export function getPluginFactory()             { return PluginFactory; }

function GetStoredValue(name, defaultValue)
{
    var key = "Setting." + name;
    var value;
    try 
    {
        value = getScriptVariableStore().Get(name);
    }
    catch(e)
    {
        logDebug("No stored value '" + key + "'; using default '" + defaultValue + "': exception is '" + e.message + "'");
    }

    if (!value)
    {
        value = defaultValue;
    }
    return value;
}

export function GetSetting(name, defaultValue)
{
    return GetStoredValue("Setting." + name, defaultValue);
}

export function GetProperty(name, defaultValue)
{
    return GetStoredValue("Property." + name, defaultValue);
}

//  </Bootstrap definitions>


var INTERVAL_HOUR = 3600000;
var IntervalTimeout = 1 * INTERVAL_HOUR; // 1h in ms
var IntervalID = 0;

function setIntervalTimeOutInHours(hours)
{
    try 
    {
        // Don't remove the parseInt. If value passed is float, the timer will throw an exception
        IntervalTimeout = parseInt(hours * INTERVAL_HOUR, 10);
    }
    catch (e)
    {
        logError("Error updating IntervalTimeOut to new value: " + hours);
    }
}

// base implementation for wrapping the variable store
var variableStore = 
{
    "get" : function(key)
    {
        return getScriptVariableStore().Get(key);
    },
    "set" : function(key, val)
    {
        return getScriptVariableStore().Set(key,val);
    }
};

export function getMessageBus() 
{
    logNormal("UWP(No-op):getMessageBus");
    globalEngine.getMessageBus  = "MessageBusString";
    return globalEngine.getMessageBus;
}

export function getPersistentStorage()
{
   logNormal("UWP: getPersistentStorage");
   var myStorage = window.localStorage;
   return myStorage;
}

globalEngine.getDaSender =  function(isUpdate) 
{
    logNormal("UWP(No-op):getDaSender");
    return null;
}

function getInProcAPIPlugin()
{
    logNormal("UWP(No-op):getInProcAPIPlugin");
    return null;
}
var delayedQueue = new Queue();

export var getDelayedRecordsQueue = function()
{
    logNormal("UWP:getDelayedRecordsQueue");
    return delayedQueue;
}

// helper to reuse the webcache object
var getWebCache = function() 
{
    logNormal("UWP(No-op):getWebCache");
    return null;
}

//init with no-op default handlers
 globalEngine.MessageBusHandler = function(value) 
{
    logNormal("UWP:MessageBusHandler:Queueing records to delayedRecordsQueue");
    logRawTrack("mBusHandler", value);
    try
    {
            var delayedRecordsQueue = getDelayedRecordsQueue();
            delayedRecordsQueue.Push(value);
    }
    catch (e)
    {
        logError("Failed to push event" + value + " to delayed records queue: " + e.message);
    }

}

var checkForContentUpdates = function()
{
    logNormal("UWP:checkForContentUpdates:Checking for content updates");
    
    startContentEngine();
}

// initialize the in-proc plugin as early as possible
try 
{
    var inprocAPI = getInProcAPIPlugin();
    // NOTE: we don't have to do anything else; we just need to instantiate it if possible.
    //       (it will be null in the normal case, not-null when an app is using the embedded API+SDK library)
}
catch (e)
{
    logError("Unexpected exception while initializing in-proc plugin: '" + e.message + "'");
}



function startContentEngine()
{
    try
    {
        // LoadScript will not re-load unless the version has changed or it isn't loaded yet
        //   so this is safe
		//LoadScript("engine.js"); // TODO: replace with factory.get(...)
		logNormal("coming here in engoine");
		StartEngine();
		logNormal("going out in engoine");
    }
    catch(e)
    {
        logError("Failed to start content processor: exception is '" + e.message + "'");
    }
}

function RunGarbageCollection()
{
    logNormal("UWP(No-op):Running garbage collection");
}

export function updateContext(args)
{
     var uwp_storage = ModuleManager.getSingleton("uwp_storage");
	 var data_collector = ModuleManager.getSingleton("data_collector");
	 if(args)
	 {
		var object = JSON.parse(args);
		for(var x in object)
		{
			data_collector.markDataExpired(x);
			uwp_storage.add(x,object[x]);
		}
	 }
}

export function ca_engine_start(args)
{
  
    logNormal("starting engine");
    try
    {
        fillMap();
        checkForContentUpdates();
		//Add Device specific details in uwp_storage container as we get in "object" from client  
        updateContext(args);
       // LoadScript("analytics_api_web.js");
        
        
        logNormal('Engine bootstrap is running');
    }
    catch (e) 
    {
	   logError("Failed in checkForContentUpdates: " + e.message);
    }
	
    return 1;
}

export function ca_engine_queuehandler( value )
{
    try
    {
        globalEngine.MessageBusHandler(value);
    }
    catch(e)
    {
    }
}

//ca_engine_start();
